import TextField from '@mui/material/TextField';
import styled from '@mui/material/styles/styled';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  color: theme.palette.inputField.default,
  borderColor: 'transparent',

  '& input:-webkit-autofill': {
    WebkitBoxShadow: `0 0 0 30px ${theme.palette.inputField.fillLight} inset !important`,
    WebkitTextFillColor: `${theme.palette.text.primary} !important`,
  },

  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.inputField.fillLight,
    borderRadius: 8,

    '& fieldset': {
      borderColor: 'transparent',
    },
  },
  '& .MuiFormHelperText-root': {
    marginBottom: '-1.125rem',
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: theme.palette.text.red,
  },
  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  'input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.border.red,
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: theme.palette.text.red,
  },
}));
